import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subscribe-popup-content__headline" }
const _hoisted_2 = { class: "subscribe-popup-content__headline-accent" }
const _hoisted_3 = { class: "subscribe-popup-content__plan-line" }

import type { InterestBook } from '@/helpers/billingSourceBook'

import BookCoverStack from '@/app/components/book/BookCoverStack.vue'
import { ContentStats } from '@/helpers/contentStats'


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscribePopupContent',
  props: {
    book: {},
    planNickname: {},
    treatment: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subscribe-popup-content", { 'subscribe-popup-content--20504': __props.treatment }])
  }, [
    _createElementVNode("h2", _hoisted_1, [
      _cache[0] || (_cache[0] = _createTextVNode(" Unlock over ", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(ContentStats).guides), 1),
      _cache[1] || (_cache[1] = _createTextVNode(" summaries ", -1))
    ]),
    (!__props.treatment)
      ? (_openBlock(), _createBlock(BookCoverStack, {
          key: 0,
          book: __props.book
        }, null, 8, ["book"]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, " Start your " + _toDisplayString(__props.planNickname) + " trial to access the full library ", 1)
  ], 2))
}
}

})